/** Keep in sync with pickads-api/.../core/plans.ts recommendPlan. */

export type RecommendKey = "starter" | "multi" | "scale";

export function recommendPlan(signals: {
  storesAnswer: 1 | 2 | 3 | 4 | 5 | null;
  marketsCount: number;
  shopifyPlus: boolean;
}): { plan: RecommendKey; why: string } {
  const s = signals.storesAnswer;
  if (s !== null && s >= 5)
    return { plan: "scale", why: "You run 5 or more stores." };
  if (s !== null && s >= 2)
    return {
      plan: "multi",
      why: `Connects your ${s} stores under one subscription.`,
    };
  if (s === null && signals.shopifyPlus)
    return {
      plan: "multi",
      why: "Most Shopify Plus brands run regional stores.",
    };
  if (signals.marketsCount > 1)
    return {
      plan: "starter",
      why: `You sell in ${signals.marketsCount} markets: block what you don't ship to, unlimited redirects, and send visitors to another website you own.`,
    };
  return {
    plan: "starter",
    why: "Unlimited redirects, block countries you don’t sell to, and send visitors to another website you own.",
  };
}

export function storesLabelToAnswer(
  label: "1" | "2-4" | "5+",
): 1 | 2 | 5 {
  if (label === "5+") return 5;
  if (label === "2-4") return 2;
  return 1;
}
